/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ otp: NonNullable<unknown>, purpose: NonNullable<unknown> }} Email_Otp_BodyInputs */

const th_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รหัสของคุณคือ ${i?.otp}

ใช้รหัสนี้เพื่อ${i?.purpose} รหัสจะหมดอายุใน 10 นาที

หากคุณไม่ได้เป็นผู้ขอรหัสนี้ กรุณาเพิกเฉยต่ออีเมลฉบับนี้ — ไม่มีใครใช้รหัสนี้ได้
หากไม่มีอีเมลของคุณ`)
};

const en_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your code is ${i?.otp}.

Use it to ${i?.purpose}. It expires in 10 minutes.

If you did not ask for this, ignore this email — nobody can use the
code without it.`)
};

const ja_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`認証コードは ${i?.otp} です。

${i?.purpose}ためにご利用ください。10分で期限切れとなります。

お心当たりがない場合は、このメールは破棄してください。コードなしで利用されることはありません。`)
};

const zh_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的验证码是 ${i?.otp}。

用它来${i?.purpose}。10 分钟后失效。

如果不是你请求的，忽略这封邮件即可——没有它，谁也无法
使用该验证码。`)
};

const es_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu código es ${i?.otp}.

Úsalo para ${i?.purpose}. Caduca en 10 minutos.

Si no lo has pedido, ignora este correo: nadie puede usar el
código sin él.`)
};

const pt_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu código é ${i?.otp}.

Use-o para ${i?.purpose}. Expira em 10 minutos.

Se você não pediu isso, ignore este e-mail — ninguém consegue usar o
código sem ele.`)
};

const id_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kode Anda adalah ${i?.otp}.

Gunakan untuk ${i?.purpose}. Kode berlaku 10 menit.

Jika Anda tidak memintanya, abaikan email ini — tanpa email ini tidak ada yang
bisa memakai kodenya.`)
};

const fr_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre code est ${i?.otp}.

Utilisez-le pour ${i?.purpose}. Il expire dans 10 minutes.

Si vous ne l’avez pas demandé, ignorez cet e-mail — personne ne peut se servir du
code sans lui.`)
};

const tl_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ang code mo ay ${i?.otp}.

Gamitin ito para ${i?.purpose}. Mag-e-expire ito sa loob ng 10 minuto.

Kung hindi ikaw ang humiling nito, huwag na lang pansinin ang email — wala nito ay walang
makakagamit ng code.`)
};

const vi_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã của bạn là ${i?.otp}.

Dùng nó để ${i?.purpose}. Mã hết hạn sau 10 phút.

Nếu bạn không yêu cầu, cứ bỏ qua thư này — không có nó thì không ai
dùng được mã.`)
};

const ko_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`코드는 ${i?.otp}입니다.

${i?.purpose} 때 사용하세요. 10분 후 만료됩니다.

요청하지 않으셨다면 이 메일을 무시하세요. 이 메일 없이는 누구도
코드를 쓸 수 없습니다.`)
};

const de_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Code lautet ${i?.otp}.

Damit kannst du ${i?.purpose}. Er läuft in 10 Minuten ab.

Wenn du das nicht angefordert hast, ignoriere diese E-Mail — ohne sie kann niemand
den Code verwenden.`)
};

const ru_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш код — ${i?.otp}.

Он нужен, чтобы ${i?.purpose}. Код истечёт через 10 минут.

Если вы его не запрашивали, не отвечайте на это письмо — без него никто
не сможет воспользоваться кодом.`)
};

const tr_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kodunuz ${i?.otp}.

Bunu ${i?.purpose} için kullanın. 10 dakika içinde geçerliliğini yitirir.

Siz istemediyseniz bu e-postayı yok sayın — o olmadan kimse kodu
kullanamaz.`)
};

const it_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo codice è ${i?.otp}.

Usalo per ${i?.purpose}. Scade tra 10 minuti.

Se non l'hai richiesto, ignora questo messaggio: senza di esso nessuno può
usare il codice.`)
};

const pl_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Twój kod to ${i?.otp}.

Użyj go, aby ${i?.purpose}. Wygaśnie za 10 minut.

Jeśli o niego nie prosiłeś, zignoruj tę wiadomość — bez niej nikt nie
użyje kodu.`)
};

const uk_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваш код — ${i?.otp}.

Він потрібен, щоб ${i?.purpose}. Код діє 10 хвилин.

Якщо ви його не запитували, проігноруйте цей лист — без нього ніхто
не скористається кодом.`)
};

const hi_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपका कोड ${i?.otp} है।

इसका उपयोग ${i?.purpose} के लिए करें। यह 10 मिनट में समाप्त हो जाएगा।

अगर आपने इसे नहीं माँगा था, तो इस ईमेल को अनदेखा करें — इसके बिना कोई भी
कोड का उपयोग नहीं कर सकता।`)
};

const ar_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`رمزك هو ${i?.otp}.

استخدمه كي ${i?.purpose}. ينتهي خلال 10 دقائق.

إن لم تطلبه، فتجاهل هذه الرسالة — فبدونها لا يستطيع أحد
استخدام الرمز.`)
};

const ms_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kod anda ialah ${i?.otp}.

Gunakannya untuk ${i?.purpose}. Ia luput dalam 10 minit.

Jika anda tidak memintanya, abaikan e-mel ini — tanpanya tiada sesiapa
boleh menggunakan kod itu.`)
};

const bn_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`আপনার কোড ${i?.otp}।

${i?.purpose} জন্য এটি ব্যবহার করুন। এটি ১০ মিনিটে শেষ হবে।

আপনি না চাইলে বার্তাটি উপেক্ষা করুন — এটি ছাড়া কেউ কোডটি
ব্যবহার করতে পারবে না।`)
};

const zh_tw2_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的驗證碼是 ${i?.otp}。

用它來${i?.purpose}。10 分鐘後失效。

若不是你要求的，忽略這封信即可——沒有它，任何人都無法
使用該驗證碼。`)
};

const zh_hk2_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的驗證碼是 ${i?.otp}。

用它來${i?.purpose}。10 分鐘後失效。

若不是你要求的，忽略這封信即可——沒有它，任何人都無法
使用該驗證碼。`)
};

const ur_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آپ کا کوڈ ${i?.otp} ہے۔

اسے ${i?.purpose} کے لیے استعمال کریں۔ یہ 10 منٹ میں ختم ہو جائے گا۔

اگر آپ نے یہ نہیں مانگا تو پیغام نظر انداز کر دیں — اس کے بغیر کوئی
کوڈ استعمال نہیں کر سکتا۔`)
};

const fa_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`کد شما ${i?.otp} است.

از آن برای ${i?.purpose} استفاده کنید. تا ۱۰ دقیقه اعتبار دارد.

اگر شما درخواستش نکرده‌اید این پیام را نادیده بگیرید — بدون آن هیچ‌کس
نمی‌تواند از کد استفاده کند.`)
};

const sw_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Msimbo wako ni ${i?.otp}.

Utumie ili ${i?.purpose}. Utaisha baada ya dakika 10.

Kama hukuuomba, puuza barua pepe hii — bila yake hakuna anayeweza
kutumia msimbo huo.`)
};

const nl_email_otp_body = /** @type {(inputs: Email_Otp_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je code is ${i?.otp}.

Gebruik hem om ${i?.purpose}. Hij vervalt over 10 minuten.

Als je hem niet hebt aangevraagd, negeer dit bericht dan — zonder
dit bericht kan niemand de code gebruiken.`)
};

/**
* | output |
* | --- |
* | "Your code is {otp}. Use it to {purpose}. It expires in 10 minutes. If you did not ask for this, ignore this email — nobody can use the code without it." |
*
* @param {Email_Otp_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_otp_body = /** @type {((inputs: Email_Otp_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Otp_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_otp_body(inputs)
	if (locale === "ja") return ja_email_otp_body(inputs)
	if (locale === "zh") return zh_email_otp_body(inputs)
	if (locale === "es") return es_email_otp_body(inputs)
	if (locale === "pt") return pt_email_otp_body(inputs)
	if (locale === "id") return id_email_otp_body(inputs)
	if (locale === "fr") return fr_email_otp_body(inputs)
	if (locale === "tl") return tl_email_otp_body(inputs)
	if (locale === "vi") return vi_email_otp_body(inputs)
	if (locale === "ko") return ko_email_otp_body(inputs)
	if (locale === "de") return de_email_otp_body(inputs)
	if (locale === "ru") return ru_email_otp_body(inputs)
	if (locale === "tr") return tr_email_otp_body(inputs)
	if (locale === "it") return it_email_otp_body(inputs)
	if (locale === "pl") return pl_email_otp_body(inputs)
	if (locale === "uk") return uk_email_otp_body(inputs)
	if (locale === "hi") return hi_email_otp_body(inputs)
	if (locale === "ar") return ar_email_otp_body(inputs)
	if (locale === "ms") return ms_email_otp_body(inputs)
	if (locale === "bn") return bn_email_otp_body(inputs)
	if (locale === "zh-TW") return zh_tw2_email_otp_body(inputs)
	if (locale === "zh-HK") return zh_hk2_email_otp_body(inputs)
	if (locale === "ur") return ur_email_otp_body(inputs)
	if (locale === "fa") return fa_email_otp_body(inputs)
	if (locale === "sw") return sw_email_otp_body(inputs)
	if (locale === "nl") return nl_email_otp_body(inputs)
	return en_email_otp_body(inputs)
});